"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userDiet = exports.default = void 0;
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _object = require("../../utils/object");
var _strings = require("../../utils/strings");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var userDiet = user => {
  var _avatar$file;
  if (!user) return {};
  var newUser = (0, _cloneDeep.default)(user);
  var {
    biography,
    avatar,
    id,
    requestedActions,
    title,
    status,
    firstname,
    lastname,
    education,
    company,
    avatarUri
  } = newUser;
  var userHealthy = {
    avatarUri: avatarUri || (avatar === null || avatar === void 0 || (_avatar$file = avatar.file) === null || _avatar$file === void 0 ? void 0 : _avatar$file.uri),
    id,
    status,
    firstname,
    lastname,
    fullname: (0, _strings.getFullname)(newUser)
  };
  if (!userHealthy.avatarUri) delete userHealthy.avatarUri;
  if (biography !== null && biography !== undefined) userHealthy.biography = biography;
  if (title) userHealthy.title = title;
  if (education !== null && education !== undefined) userHealthy.education = education;
  if (company !== null && company !== undefined) userHealthy.company = company;
  if (requestedActions) userHealthy.requestedActions = requestedActions;
  return (0, _object.clearObject)(userHealthy);
};
exports.userDiet = userDiet;
var _default = exports.default = {
  userDiet
};